<app-common-page-breadcrumbs [navigationData]="navigationData" [pageTitle]="title"></app-common-page-breadcrumbs>
<div class="container py-4 d-flex justify-content-center">
  <!-- <div class="d-flex justify-content-center"> -->
    <ng-container>
      <form (ngSubmit)="submitForm()" class="" [formGroup]="addcontactform">
        <div class="form-row ">
          <div class="form-group mt-3 col-md-2">
            <label for="Salutation">{{'heading.Salutation' | cxTranslate}}</label>
            <select id="Salutation" class="form-control form-control-lg  p-0" formControlName="titleCode">
              <option class="input" *ngFor="let sal of salutation" value="{{sal.code}}">{{sal.name}}</option>
            </select>
          </div>
          <div class="form-group mt-3 col-md-5">
            <label for="Firstname">{{'heading.Firstname' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg " id="Firstname" formControlName="firstName" maxlength="40">
          </div>
          <div class="form-group mt-3 col-md-5">
            <label for="Lastname">{{'heading.Lastname' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg " id="Lastname" formControlName="lastName" maxlength="40">
            <p *ngIf="addcontactform.controls.lastName.errors?.required && addcontactform.controls.lastName.dirty"
              class="text-danger f-14">{{'home.validation.Field' | cxTranslate}}</p>
            <p *ngIf="addcontactform.controls.lastName.errors?.pattern && addcontactform.controls.lastName.dirty"
              class="text-danger f-14"> {{'home.validation.special' | cxTranslate}}</p>
          </div>
        </div>
        <div class="form-group mt-3 mb-3">
          <label for="Email">{{'heading.E-mail*' | cxTranslate}}</label>
          <input type="email" class="form-control form-control-lg " id="Email" formControlName="email" disabled>
          <p *ngIf="addcontactform.controls.email.errors?.required && addcontactform.controls.email.dirty"
            class="text-danger f-14">{{'home.validation.Field' | cxTranslate}}</p>
          <p *ngIf="addcontactform.controls.email.errors?.pattern && addcontactform.controls.email.dirty"
            class="text-danger f-14"> {{'home.validation.email' | cxTranslate}}</p>
        </div>
        <div class="form-group mt-4 mb-3">
          <label for="Mobile"> {{'heading.Mobile' | cxTranslate}}</label>
          <input type="text" class="form-control form-control-lg " id="Mobile" formControlName="mobileNumber" maxlength="40">
          <p *ngIf="addcontactform.controls.mobileNumber.errors?.pattern && addcontactform.controls.mobileNumber.dirty"
            class="text-danger f-14">{{'home.validation.mobile' | cxTranslate}}</p>

        </div>
        <div class="form-group mt-4 mb-3">
          <label for="AlternateNumber"> {{'heading.AlternateNumber' | cxTranslate}}</label>
          <input type="text" class="form-control form-control-lg " id="AlternateNumber" formControlName="alternateNumber" maxlength="40">
          <p *ngIf="addcontactform.controls.alternateNumber.errors?.pattern && addcontactform.controls.alternateNumber.dirty"
            class="text-danger f-14">{{'home.validation.mobile' | cxTranslate}}</p>
        </div>
        <div class="form-group mt-4 mb-3 d-none">
          <label for="jobTitle"> {{'heading.Designatedcontact' | cxTranslate}}</label>
          <input type="text" class="form-control form-control-lg input" id="jobTitle" formControlName="jobTitle" maxlength="40">
        </div>
        <div class="form-group mt-4 mb-3">
          <label for="Department"> {{'heading.Department' | cxTranslate}}</label>
          <input type="text" class="form-control form-control-lg " id="Department" formControlName="department" maxlength="80">
        </div>
        <hr>
        <h3 class='h5 strong'> {{'heading.ShoppingDetails' | cxTranslate}}</h3>

        <div class="form-check" *ngFor="let mod of modcontact;let i = index">
          <input class="form-check-input border-white bg-white " type="radio" id="mot{{i}}" name="modeOfContact"
            formControlName="modeOfContact" value="{{mod.id}}">
          <label class="form-check-label text-dark" for="mot{{i}}">
            {{mod.name}}
          </label>
        </div>
        <!-- <hr> -->
        <!-- <div class="form-group mt-3 mb-3">
          <label for="companyName" class="h5 strong">Group company</label>
          <input type="text" class="form-control form-control-lg " id="companyName" formControlName="name" disabled>
        </div> -->
        <div class="form-group mt-5 mb-3">
          <button class="btn btn-block btn-primary btn-lg" type="submit" (click)="createcontact(addcontactform.value)"
            [disabled]="isDisabled|| !addcontactform.valid || isSaveDisabled">
            {{'heading.Save' | cxTranslate}}
          </button>
        
          <button class="btn btn-block btn-secondary btn-lg" type="submit" (click)="navigateToDetails()">
            {{'heading.Cancel' | cxTranslate}}
          </button>
        </div>
      </form>
    </ng-container>
  <!-- </div> -->
<div>
